import React from "react";
import { Genders } from "../../Helpers/AppConstants";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";

type attributes = {
    title: string,
    dayShiftCount: number,
    nightShiftCount: number
}

export const ShiftWorkStat = (props: attributes) => {

    const iconByGender = () => {
        if (props.title === Genders.MALE)
            return 'gender-male';
        else if (props.title === Genders.FEMALE)
            return 'gender-female';
        else
            return 'clock-history';
    }

    return (
        <div className="d-inline-flex justify-content-start align-items-center px-3 py-2 rounded shift-stat-container gap-3">
            {/* <div>
                <BootstrapIcon bootStrapIconName={iconByGender()} size={48} cssClasses='text-gray-dim' />
            </div> */}
            <div  className="text-center">
                <b className="text-gray">{props.title.toUpperCase()}</b>
                <div className="d-flex inline-flex justify-content-start text-end align-items-center gap-4">
                    <div>
                        <h3>{props.dayShiftCount}</h3>
                        <BootstrapIcon bootStrapIconName="brightness-high" size={12} cssClasses='pe-1' /><small>Day</small>
                    </div>
                    <div>
                        <h3>{props.nightShiftCount}</h3>
                        <BootstrapIcon bootStrapIconName="moon-fill" size={12} cssClasses='pe-1' /><small>Night</small>
                    </div>
                </div>
            </div>
        </div>
    )
}